import { render, staticRenderFns } from "./userManagementone.vue?vue&type=template&id=94463a1a"
import script from "./userManagementone.vue?vue&type=script&lang=js"
export * from "./userManagementone.vue?vue&type=script&lang=js"
import style0 from "./userManagementone.vue?vue&type=style&index=0&id=94463a1a&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports